(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/utils/get-vouchers.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/utils/get-vouchers.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const fetchData = async req => {
  try {
    const _await$req = await req,
      response = _await$req.response;
    return response;
  } catch (e) {
    var _e$responseJSON$error, _e$responseJSON;
    return {
      error: (_e$responseJSON$error = e === null || e === void 0 || (_e$responseJSON = e.responseJSON) === null || _e$responseJSON === void 0 ? void 0 : _e$responseJSON.error) !== null && _e$responseJSON$error !== void 0 ? _e$responseJSON$error : e
    };
  }
};
const getVouchers = async giftcode => {
  if (giftcode) {
    return new Promise(async (resolve, reject) => {
      var _voucherMetadata$pers;
      svs.components.loader.show();
      const voucherId = giftcode.toUpperCase();
      const _await$Promise$all = await Promise.all([fetchData(svs.tur.apiCaller.ticketgames.getVoucherMetadata({
          voucherId
        })), fetchData(svs.tur.apiCaller.ticketgames.getVoucherById({
          voucherId
        }))]),
        _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
        voucherMetadata = _await$Promise$all2[0],
        vouchersData = _await$Promise$all2[1];
      svs.components.loader.hide();
      const personalMessage = voucherMetadata === null || voucherMetadata === void 0 || (_voucherMetadata$pers = voucherMetadata.personalMessage) === null || _voucherMetadata$pers === void 0 ? void 0 : _voucherMetadata$pers.replace(/\\n/g, '\n');
      if (!vouchersData.voucherInfo) {
        if ((voucherMetadata === null || voucherMetadata === void 0 ? void 0 : voucherMetadata.vouchers.length) === 1 && voucherMetadata.vouchers[0].voucherId === giftcode.slice(0, 8) && giftcode.length === 12) {
          resolve(_objectSpread(_objectSpread({}, voucherMetadata), {}, {
            vouchers: [_objectSpread(_objectSpread({}, voucherMetadata.vouchers[0]), {}, {
              voucherId: giftcode
            })]
          }));
        }
        reject(vouchersData.error);
      }
      if (!voucherMetadata.vouchers) {
        resolve(_objectSpread(_objectSpread(_objectSpread({}, voucherMetadata), vouchersData), {}, {
          personalMessage,
          vouchers: vouchersData.voucherInfo.map(voucher => _objectSpread(_objectSpread({}, voucher), {}, {
            voucherConfigId: voucher.packageId,
            value: voucher.voucherValue
          }))
        }));
      }
      resolve(_objectSpread(_objectSpread({}, voucherMetadata), {}, {
        personalMessage,
        receiverSameAsBuyer: vouchersData.receiverSameAsBuyer,
        vouchers: voucherMetadata.vouchers.map(metadata => {
          const voucherInfo = vouchersData.voucherInfo.find(voucher => voucher.voucherId.slice(0, 8) === metadata.voucherId);
          return _objectSpread(_objectSpread({}, metadata), {}, {
            voucherId: voucherInfo.voucherId,
            value: metadata.value || voucherInfo.voucherValue
          });
        })
      }));
    });
  }
  return {};
};
setGlobal('svs.ticket_gifts.utils.getVouchers', getVouchers);

 })(window);